import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';


const ChargesGridPlain = ({ expenses, setExpenses, setPriority, priority, setBillTo, billTo, setCurrency, currency, setSupplier, supplier, setSupplierName, supplierName }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [loadingSuppliers, setLoadingSuppliers] = useState(false);

    useEffect(() => {
        const fetchSuppliers = async () => {
            if (billTo && currency) {
                let tipo = '';
                if (billTo === 'Cliente' && currency === 'MXP') {
                    tipo = '02';
                } else if (billTo === 'Cliente' && currency === 'USD') {
                    tipo = '04';
                } else if (billTo === 'Agencia Aduanal' && currency === 'MXP') {
                    tipo = '01';
                } else if (billTo === 'Agencia Aduanal' && currency === 'USD') {
                    tipo = '03';
                }

                try {
                    setLoadingSuppliers(true);
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/payment_request/getSuppliers`, { params: { tipo } });
                    const options = response.data.map(supplier => ({ value: supplier.Clave, label: supplier.Clave + ' - ' + supplier.Nombre }));
                    setSuppliers(options);
                } catch (error) {
                    console.error('Error fetching suppliers:', error);
                } finally {
                    setLoadingSuppliers(false);
                }
            }
        };

        fetchSuppliers();
    }, [billTo, currency]);

    const handleSupplierChange = (selectedOption) => {
        // Update the supplier state with the selected option's value
        setSupplier(selectedOption ? selectedOption.value : '');
        // Extract and set the supplier name from the selected option's label
        // Assuming the label is in the format "Clave - Nombre"
        setSupplierName(selectedOption ? selectedOption.label.split(' - ')[1] : '');
    };
    // Initialize each category if not present
    const initializedExpenses = {
        arrival_expenses: expenses.arrival_expenses || [],
        dispatch_expenses: expenses.dispatch_expenses || [],
        operation_closure_expenses: expenses.operation_closure_expenses || [],
    };

    const sampleConcepts = {
        arrival_expenses: ['Pagos Locales', 'Revalidacion', 'Muellaje', 'Seguridad', 'Previo'],
        dispatch_expenses: ['Descarga Buque a Piso', 'Arrastre de Piso a Patio', 'Entrega de Patio a Camion', 'Servicio de Administracion', 'Control Electronico Documental', 'Comisiones Bancarias', 'Maniobras', 'Carga y Descarga'],
        operation_closure_expenses: ['Entrega de Vacios', 'Lavado de Contenedor', 'Reparacion de Contenedor', 'Almacenajas', 'Demoras']
    };

    const updatePriority = (newPriority) => {
        setPriority(newPriority);
    };

    const handleAdd = (category) => {
        const newExpense = {
            tempId: Date.now().toString(),
            concept: sampleConcepts[category][0],  // Default to the first concept in the list
            amount: 0,
            date_added: new Date().toISOString().split('T')[0],
        };
        setExpenses({
            ...initializedExpenses,
            [category]: [...initializedExpenses[category], newExpense],
        });
    };


    const formatAmount = (value) => {
        // Remove any non-numeric characters except for the dot
        let cleanValue = value.replace(/[^0-9.]/g, '');

        // Ensure there's only one dot
        const parts = cleanValue.split('.');
        if (parts.length > 2) {
            cleanValue = parts[0] + '.' + parts.slice(1).join('');
        }

        // Ensure only two decimal places
        if (parts[1] && parts[1].length > 2) {
            cleanValue = parts[0] + '.' + parts[1].substr(0, 2);
        }

        return cleanValue;
    };

    const handleInputChange = (e, category, expenseId, field) => {
        let value = e.target.value;
        if (field === 'amount') {
            value = formatAmount(value);
        }
        setExpenses({
            ...initializedExpenses,
            [category]: initializedExpenses[category].map(expense => {
                if (expense.tempId === expenseId || expense._id === expenseId) {
                    return { ...expense, [field]: value };
                }
                return expense;
            }),
        });
    };



    const handleDelete = (category) => {
        console.log("Expenses before delete:", initializedExpenses[category]);
        console.log("Selected rows:", selectedRows);

        setExpenses({
            ...initializedExpenses,
            [category]: initializedExpenses[category].filter((expense) => {
                const expenseId = expense._id || expense.tempId;
                return !selectedRows.includes(expenseId);
            }),
        });
        setSelectedRows([]); // Clear the selected rows
    };



    return (
        <div className="p-4 text-sm bg-white shadow rounded-lg overflow-hidden">
            <div className="flex justify-between items-center space-x-4">
                <div className="flex flex-col">
                    <label htmlFor="priority" className="block text-sm font-medium text-gray-700 mb-1">
                        Priority:
                    </label>
                    <select
                        id="priority"
                        value={priority}
                        onChange={(e) => setPriority(e.target.value)}
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    >
                        <option value="Normal">Normal</option>
                        <option value="Urgent">Urgent</option>
                    </select>
                </div>
                <div className="flex flex-col">
                    <label htmlFor="billTo" className="block text-sm font-medium text-gray-700 mb-1">
                        Bill To:
                    </label>
                    <select
                        id="billTo"
                        value={billTo}
                        onChange={(e) => setBillTo(e.target.value)}
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    >
                        <option value="Cliente">Cliente</option>
                        <option value="Agencia Aduanal">Agencia Aduanal</option>
                    </select>
                </div>
                <div className="flex flex-col">
                    <label htmlFor="currency" className="block text-sm font-medium text-gray-700 mb-1">
                        Currency:
                    </label>
                    <select
                        id="currency"
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    >
                        <option value="MXP">MXP</option>
                        <option value="USD">USD</option>
                    </select>
                </div>
                <div className="flex flex-col">
                    <label htmlFor="supplier" className="block text-sm font-medium text-gray-700 mb-1">
                        Supplier:
                    </label>
                    <Select
                        id="supplier"
                        value={suppliers.find(option => option.value === supplier)}
                        onChange={handleSupplierChange}
                        options={suppliers}
                        isLoading={loadingSuppliers}
                        isSearchable={true}
                        isClearable={true}
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    />
                </div>
            </div>
            {["arrival_expenses", "dispatch_expenses", "operation_closure_expenses"].map(category => (
                <div key={category} className="mb-8">
                    <h2 className="text-xl font-semibold mb-4 text-blue-900 capitalize">{category.replace(/_/g, ' ')}</h2>
                    <table className="min-w-full text-left border border-blue-200 divide-y divide-blue-200">
                        <thead className="bg-blue-50">
                            <tr>
                                <th className="px-3 py-2">Select</th>
                                <th className="px-3 py-2">ID</th>
                                <th className="px-3 py-2">Concept</th>
                                <th className="px-3 py-2">Amount</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-blue-200">
                            {initializedExpenses[category].map(expense => (
                                <tr key={expense.tempId || expense._id}>
                                    <td className="border px-4 py-2">
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(expense.tempId || expense._id)}
                                            onChange={(e) => {
                                                const currentId = expense.tempId || expense._id;
                                                if (e.target.checked) {
                                                    setSelectedRows([...selectedRows, currentId]);
                                                } else {
                                                    setSelectedRows(selectedRows.filter(id => id !== currentId));
                                                }
                                            }}
                                        />
                                    </td>
                                    <td className="border px-4 py-2">{expense.tempId || expense._id}</td>
                                    <td className="border px-3 py-1">
                                        <select
                                            className="border rounded px-1 py-1 w-full"
                                            value={expense.concept}
                                            onChange={(e) => handleInputChange(e, category, expense.tempId || expense._id, 'concept')}
                                        >
                                            <option value="" disabled>Select Concept</option>
                                            {sampleConcepts[category].map(concept => (
                                                <option key={concept} value={concept}>{concept}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="border px-4 py-2">
                                        <input
                                            type="text"
                                            className="border rounded px-2 py-1 w-full"
                                            value={`$${expense.amount}`}
                                            onChange={(e) => handleInputChange(e, category, expense.tempId || expense._id, 'amount')}
                                            placeholder="$0.00"
                                        />
                                    </td>
                                    
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="mt-4 flex justify-start">
                        <button
                            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded mr-2"
                            onClick={() => handleAdd(category)}
                        >
                            Add
                        </button>
                        <button
                            className="bg-red-500 hover:bg-red-600 text-white font-semibold px-4 py-2 rounded"
                            onClick={() => handleDelete(category)}
                        >
                            Delete Selected
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

ChargesGridPlain.defaultProps = {
    expenses: {
        arrival_expenses: [],
        dispatch_expenses: [],
        operation_closure_expenses: []
    },
    setExpenses: () => { }
};

export default ChargesGridPlain;
